//List of TE icons in assets, used as check to avoid image load errors

/// TODO Needs to be removed!!! Will be removed together with TransitionElement enum: https://app.asana.com/0/1204511308780267/1204537460072217
export enum TransitionElementIcon {
  'biofuels_for_air_transport',
  'biofuels_for_cement_and_mineral_industry',
  'biofuels_for_metal_industry',
  'biofuels_for_military_transport',
  'biofuels_for_other_industry',
  'biofuels_for_paper_and_pulp_industry',
  'biofuels_for_sea_freight_transport',
  'biofuels_for_sea_passenger_transport',
  'biofuels_replacing_coal',
  'biofuel_for_heavy_trucks',
  'biofuel_for_light_trucks',
  'car_pools_and_rental_cars',
  'ccs_ccu_for_chemical_industry',
  'ccs_ccu_for_refineries',
  'ccs_for_cement_and_concrete_industry',
  'ccs_from_solid_biofuels_beccs',
  'ccs_from_waste_incineration',
  'changed_production',
  'coal_fired_power_plants',
  'destruction_of_fluorinated_gases',
  'ecodriving_of_cars',
  'ecodriving_of_heavy_trucks',
  'ecodriving_of_light_trucks',
  'ecodriving_of_trucks',
  'efficient_treatment_of_sewage_water_and_sludge',
  'efficient_use_of_mobile_machinery',
  'electric_light_trucks',
  'electric_passenger_airplanes',
  'electrification_of_domestic_sea_freight_transport',
  'electrification_of_domestic_sea_passenger_transport',
  'electrification_of_mobile_machinery',
  'electrification_of_other_industries',
  'electrification_of_production_in_cement_and_concrete_industry',
  'electrification_of_production_in_iron_and_steel_industry',
  'electrification_of_production_in_paper_and_pulp_industry',
  'energy_efficient_multi_family_residential_buildings_retrofitting',
  'energy_efficient_new_commercial_buildings',
  'energy_efficient_new_housing',
  'energy_efficient_non_residential_commercial_buildings_retrofitting',
  'energy_efficient_non_residential_industrial_buildings_retrofitting',
  'energy_efficient_non_residential_public_buildings_retrofitting',
  'energy_efficient_single_family_residential_buildings_retrofitting',
  'fertiliser_from_an_aerobic_digestion_in_biogas_production',
  'food_additives',
  'gas_fired_power_plants',
  'gas_heavy_trucks',
  'gas_light_trucks',
  'heating_housing_and_buildings_with_renewable_solid_biofuels',
  'heating_multi_family_residential_buildings_with_renewable_solid_biofuels',
  'heating_non_residential_commercial_buildings_with_renewable_solid_biofuels',
  'heating_non_residential_industrial_buildings_with_renewable_solid_biofuels',
  'heating_non_residential_public_buildings_with_renewable_solid_biofuels',
  'heating_single_family_residential_buildings_with_renewable_solid_biofuels',
  'heat_pumps_in_multi_family_residential_buildings',
  'heat_pumps_in_non_residential_commercial_buildings',
  'heat_pumps_in_non_residential_industrial_buildings',
  'heat_pumps_in_non_residential_public_buildings',
  'heat_pumps_in_single_family_residential_buildings',
  'hydro_reservoir',
  'hydrogen_blended_in_the_gas_mix_for_heating_buildings',
  'hydrogen_for_heavy_trucks',
  'hydrogen_for_light_trucks',
  'imported_grid_electricity',
  'imported_grid_electricity_emission_factor',
  'improved_energy_efficiency_and_hybridisation_of_mobile_machinery',
  'improved_grid_electricity',
  'improved_load_factor_heavy_trucks',
  'improved_load_factor_light_trucks',
  'improved_urban_planning',
  'improved_vehicle_technology',
  'improved_vehicle_technology_heavy_trucks',
  'improved_vehicle_technology_light_trucks',
  'increased_effectiveness_by_plant_breeding_and_culturing',
  'increased_energy_recovery_from_waste',
  'increased_proportion_of_commuting_by_electric_bus',
  'increased_proportion_of_non_travel_meetings_and_services',
  'increased_proportion_of_public_transport_by_trams_and_light_rail',
  'increased_proportion_of_walking_and_cycling',
  'increased_recycling',
  'increased_resource_efficiency',
  'increased_use_of_recycled_metal',
  'increased_use_of_recycled_plastics',
  'increase_renewable_proportion_in_diesel',
  'increase_renewable_proportion_in_petrol',
  'inert_anodes',
  'low_carbon_construction_of_buildings',
  'low_carbon_construction_of_multi_family_residential_housing',
  'low_carbon_construction_of_non_residential_commercial_buildings',
  'mobile_machinery_using_biofuels',
  'more_efficient_commuting_by_car',
  'more_efficient_passenger_airplanes',
  'more_efficient_sea_freight_transportation',
  'more_efficient_sea_passenger_transportation',
  'more_efficient_use_of_commercial_area',
  'more_efficient_use_of_living_area',
  'nitrification_reducers',
  'oil_fired_power_plants',
  'optimisation_of_concrete',
  'optimising_fertiliser_use',
  'production_using_hydrogen',
  'pv_on_roof_tops',
  'reduced_food_waste',
  'reduced_leakage',
  'reduced_production_of_waste',
  'reduced_proportion_of_fossil_waste',
  'reduced_use_of_solvents',
  'reduce_evaporation_of_liquid_fertiliser',
  'renewable_hydrogen',
  'renewable_raw_materials_for_chemical_industry',
  'renewable_raw_materials_for_refineries',
  'replacement_of_fluorinated_gases',
  'replace_peat_with_biofuels',
  'replacing_solvents_with_alternatives',
  'rewetting',
  'route_optimisation_light_trucks',
  'shift_from_passenger_air_transport_to_railway',
  'shift_to_biofuel_in_district_heating',
  'shift_to_biogas_heating_of_non_residential_commercial_buildings',
  'shift_to_biogas_heating_of_single_family_residential_buildings',
  'shift_to_district_heating_in_buildings',
  'shift_to_district_heating_in_commercial_buildings',
  'shift_to_district_heating_in_industrial_buildings',
  'shift_to_district_heating_in_multi_family_buildings',
  'shift_to_district_heating_in_public_buildings',
  'shift_to_district_heating_in_single_family_houses',
  'shift_to_electric_heavy_trucks',
  'shift_to_electric_vehicles',
  'shift_to_gas_vehicles',
  'shift_to_heat_pumps_in_district_heating',
  'shift_to_lng_fuel_for_sea_freight_transportation',
  'shift_to_lng_fuel_for_sea_passenger_transportation',
  'shift_to_residual_heat_in_district_heating',
  'solar_parks',
  'solar_rooftops',
  'transfer_from_car_to_railway',
  'transfer_from_car_to_remote_working',
  'transfer_from_heavy_truck_to_electric_railway',
  'transfer_from_heavy_truck_to_sea',
  'wind_onshore',
  'wind_power',
  'wind_offshore',
  'chp_biofuels',
  'chp_coal',
  'chp_natural_gas',
  'chp_oil',
  'chp_waste_incineration',
  'district_heating_heat_pumps',
  'district_heating_residual_heat',
  'imported_grid_district_heat',
  'imported_grid_district_heat_emission_factor',
  'increased_proportion_of_public_transport_by_diesel_bus',
  'increased_proportion_of_public_transport_by_gas_bus',
  'shift_to_district_cooling_in_single_family_buildings',
  'shift_to_district_cooling_in_multi_family_buildings',
  'energy_efficient_single_family_residential_buildings_cooling',
  'energy_efficient_multi_family_residential_buildings_cooling',
  'efficient_use_single_family_residential_buildings_cooling',
  'efficient_use_multi_family_residential_buildings_cooling',
  'shift_to_solar_thermal_in_single_family_buildings',
  'shift_to_solar_thermal_in_multi_family_buildings',
  'shift_to_solar_thermal_in_public_buildings',
  'shift_to_solar_thermal_in_commercial_buildings',
  'energy_efficient_non_residential_commercial_buildings_retrofitting_cooling',
  'energy_efficient_non_residential_industrial_buildings_retrofitting_cooling',
  'energy_efficient_non_residential_public_buildings_retrofitting_cooling',
  'increased_proportion_of_public_transport_by_hydrogen_bus',
  'shift_to_district_cooling_in_commercial_buildings',
  'shift_to_district_cooling_in_industrial_buildings',
  'shift_to_district_cooling_in_public_buildings',
  'shift_to_electric_cargo_bikes',
  'shift_to_hydrogen_vehicles',
  'shift_to_solar_thermal_in_industrial_buildings',
  'energy_efficient_multi_family_residential_buildings_retrofitting_cooling',
  'energy_efficient_single_family_residential_buildings_retrofitting_cooling',
  'shift_to_electric_bikes',
  'increased_proportion_of_public_transport_by_lpg_bus',
  'increased_proportion_of_public_transport_by_petrol_bus',
  'biofuel_for_diesel_buses',
  'biofuel_for_diesel_rail_freight',
  'biofuel_for_diesel_rail_passenger',
  'biofuel_for_gas_buses',
  'biofuel_for_gas_vehicles',
  'biofuel_for_lng_shipping_freight',
  'biofuel_for_lng_shipping_passenger',
  'biofuel_for_petrol_buses',
  'biofuel_for_petrol_heavy_trucks',
  'biofuel_for_petrol_light_trucks',
  'biofuel_for_petrol_motorcycles',
  'shift_to_electric_freight_rail',
  'shift_to_electric_motorcycles',
  'shift_to_electric_passenger_rail',
  'shift_to_hydrogen_freight_rail',
  'shift_to_hydrogen_passenger_rail',
  'district_heating_oil',
  'district_heating_waste',
  'district_heating_geothermal_heat',
  'district_heating_coal',
  'chp_hydrogen',
  'chp_landfill_gas',
  'district_heating_biogas',
  'district_heating_natural_gas',
  'sludge_fired_power_plants',
  'chp_sludge',
  'chp_biogas',
  'district_heating_biofuel',
  'district_heating_solar_thermal',
  'district_heating_sludge',
  'district_heating_hydrogen',
  'hydrogen_fired_power_plants',
  'district_heating_landfill_gas',
  'waste_fired_power_plants',
  'biofuel_fired_power_plants',
  'district_heating_water_sourced_heat_pumps',
  'more_efficient_freight_airplanes',
  'biofuels_for_freight_air_transport',
  'shift_from_freight_air_transport_to_railway',
  'electric_freight_airplanes',
  'energy_efficient_other_agriculture_forestry_fishing_electric_appliances',
  'energy_efficient_other_commercial_electric_appliances',
  'energy_efficient_other_industrial_electric_appliances',
  'energy_efficient_other_institutional_electric_appliances',
  'energy_efficient_other_residential_electric_appliances',
  'energy_efficient_street_lighting',
  'shift_to_residential_electric_cooking_stoves',
  'shift_to_commercial_electric_cooking_stoves',
  'biogas_in_methane_reforming_for_ammonia_production',
  'biogas_in_methane_reforming_for_hydrogen_production',
  'biomass_in_carbon_gasification_for_hydrogen_production',
  'shift_to_biogas_energy_in_chemical_industries',
  'shift_to_biogas_energy_in_glass_industries',
  'shift_to_biogas_energy_in_hydrogen_refinement',
  'shift_to_biogas_energy_in_iron_and_steel_industries',
  'shift_to_biogas_energy_in_pulp_paper_and_print_industries',
  'shift_to_biomass_energy_in_chemical_industries',
  'shift_to_biomass_energy_in_glass_industries',
  'shift_to_biomass_energy_in_hydrogen_refinement',
  'shift_to_biomass_energy_in_iron_and_steel_industries',
  'shift_to_biomass_energy_in_petroleum_refinement',
  'shift_to_biomass_energy_in_pulp_paper_and_print_industries',
  'shift_to_electric_arc_furnaces_in_steel_industries',
  'shift_to_electricity_in_chemical_industries',
  'shift_to_electricity_in_glass_industries',
  'shift_to_electricity_in_hydrogen_refinement',
  'shift_to_electricity_in_iron_and_steel_industries',
  'shift_to_electricity_in_pulp_paper_and_print_industries',
  'shift_to_electrolysis_of_water_for_hydrogen_production',
  'shift_to_hydrogen_energy_in_chemical_industries',
  'shift_to_hydrogen_energy_in_glass_industries',
  'shift_to_hydrogen_energy_in_iron_and_steel_industries',
  'shift_to_hydrogen_energy_in_pulp_paper_and_print_industries',
  'shift_to_inert_anodes_in_aluminium_industries',
  'energy_efficient_commercial_lighting',
  'improved_vehicle_technology_buses',
  'shift_to_landfill_gas_recovery',
  'shift_to_composting_of_organic_waste',
  'shift_to_exported_composting_of_organic_waste',
}
